import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const InspectorRow = props => (
  <div className={`${props.className || ""} inspectorRow${props.verticalCenter ? " verticalCenter" : ""}`}>
    {props.label ? <label className={props.brightLabel ? "bright" : ""}>{props.label}</label> : null}
    {props.children}
  </div>
);

InspectorRow.propTypes = {
  label: PropTypes.string,
  brightLabel: PropTypes.bool,
  verticalCenter: PropTypes.bool,
  children: PropTypeShapes.elementOrArrayOrList,
  className: PropTypes.string
};

export default InspectorRow;
